import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Download, Share2, ImageIcon, Sparkles, Search, Trash2 } from 'lucide-react';
import { api, fileUrl } from '@/lib/api';
import { luxe, gradientCss } from '@/lib/luxe';

function copyShare(url) {
  navigator.clipboard.writeText(fileUrl(url));
  toast.success('Share link copied 🔗');
}

const Actions = ({ url, testid, onDelete }) => (
  <div className="absolute inset-x-0 bottom-0 p-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.75), transparent)' }}>
    <a href={fileUrl(url)} download data-testid={`${testid}-download`} className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-xs font-bold" style={{ background: gradientCss(['#EC4899', '#A855F7']), color: '#fff' }}><Download size={13} /> Download</a>
    <button onClick={() => copyShare(url)} data-testid={`${testid}-share`} className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-xs font-bold" style={{ background: 'rgba(255,255,255,0.14)', color: '#fff' }}><Share2 size={13} /> Share</button>
    <button onClick={onDelete} data-testid={`${testid}-delete`} className="flex items-center justify-center px-2 py-1.5 rounded-lg" style={{ background: 'rgba(239,68,68,0.85)', color: '#fff' }}><Trash2 size={13} /></button>
  </div>
);

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  useEffect(() => {
    api('/myra-chat/gallery').then((r) => setImages(r.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const ql = q.trim().toLowerCase();
  const delImage = async (path) => { await api('/myra-chat/gallery/delete', { method: 'POST', body: { path } }); setImages((im) => im.filter((x) => x.path !== path)); toast.success('Image deleted'); };
  const fImages = images.filter((im) => !ql || (im.prompt || '').toLowerCase().includes(ql));
  const empty = !loading && fImages.length === 0;

  return (
    <div className="space-y-6" data-testid="gallery-page">
      <div>
        <div className="text-[11px] font-extrabold uppercase tracking-widest" style={{ color: luxe.muted }}>Studio</div>
        <h1 className="font-display text-4xl font-black" style={{ color: luxe.text }}>Creative <span className="gold-text">Gallery</span></h1>
        <p className="mt-2 text-sm" style={{ color: luxe.textMid }}>Har image aur poster yahan auto-save hoti hai — download ya share karo.</p>
      </div>

      <div className="flex items-center justify-end gap-3 flex-wrap">
        <div className="flex items-center gap-2 px-3 py-2 rounded-xl" style={{ background: luxe.surface, border: `1px solid ${luxe.border}` }}>
          <Search size={15} style={{ color: luxe.muted }} />
          <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="gallery-search" placeholder="Search…" className="bg-transparent outline-none text-sm" style={{ color: luxe.text }} />
        </div>
      </div>

      {empty && (
        <div className="py-24 text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: gradientCss(['#EC4899', '#A855F7']) }}><Sparkles size={30} color="#fff" /></div>
          <div className="font-bold text-lg" style={{ color: luxe.text }}>{q ? 'Kuch nahi mila' : 'Gallery abhi khaali hai'}</div>
          <div className="text-sm mt-1" style={{ color: luxe.muted }}>Myra Assistant se koi image/poster banao — yahan aa jayegi.</div>
        </div>
      )}

      {!empty && (
        <div>
          <div className="flex items-center gap-2 mb-3"><ImageIcon size={16} style={{ color: luxe.pink }} /><h2 className="text-lg font-bold" style={{ color: luxe.text }}>Images & Posters</h2></div>
          <div className="grid sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {fImages.map((im, i) => (
              <div key={i} className="group relative rounded-2xl overflow-hidden" style={{ background: luxe.bgElev, border: `1px solid ${luxe.border}` }} data-testid={`gallery-image-${i}`}>
                <img src={fileUrl(im.url)} alt={im.prompt || 'creation'} className="w-full aspect-square object-cover" />
                <Actions url={im.url} testid={`gallery-image-${i}`} onDelete={() => delImage(im.path)} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
